@if (!embedded) {
<div class="modal-header ">
  <h4 class="modal-title header-5">
    {{ configs.title }}
  </h4>
  <button type="button" class="accello-icon-btn" (mousedown)="isActive = true" (mouseup)="isActive = false"
    (mouseleave)="isActive = false" (click)="onCancel()">
    <img [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="Close" />
  </button>
</div>
}

@if(isLoading){
<div class="loading-div w-100 d-flex justify-content-center align-items-center" *ngIf="isLoading">
  <app-loading [text]="'Loading...'"></app-loading>
</div>
} @else{

<div class="modal-body">
  <div class="row">

    @if (isAlm) {
    <!-- Provider -->

    <div class="mb-3" [class.col-md-12]="isAlm" [class.col-md-6]="!isAlm">
      <label class="form-label general-text-6" for="providerSelect">
        Provider<span class="text-danger">*</span>
      </label>
      <div class="provider-tiles" role="group" aria-label="Provider">
        <span
          *ngFor="let item of providersFieldsList"
          class="provider-tile-wrap"
          [matTooltip]="providerDisabledHint(item)"
          matTooltipPosition="below"
        >
          <button type="button" class="provider-tile"
            [class.provider-tile--active]="isProviderSelected(item)"
            [disabled]="configs?.isEdit || isProviderDisabled(item)"
            (click)="onSelectChange(item.value)">
            {{ item.label }}
          </button>
        </span>
      </div>
    </div>

    <!-- Connection Name -->
    @if (!hideConnectionName) {
    <div class="mb-3 col-md-12">
      <label class="form-label general-text-6" for="connName">
        Connection Name<span class="text-danger">*</span>
      </label>
      <input id="connName" type="text" [disabled]="configs?.isEdit" class="form-control" [(ngModel)]="connName"
        placeholder="Enter connection name" />
    </div>
    }
    } @else if (isDb) {
    <!-- Connection Name -->
    <div class="mb-3 col-md-6">
      <label class="form-label general-text-6" for="connName">
        Connection Name<span class="text-danger">*</span>
      </label>
      <input id="connName" type="text" [disabled]="configs?.isEdit" class="form-control" [(ngModel)]="connName"
        placeholder="add connection name" />
    </div>

    <!-- Database Type -->
    <div class="mb-3 col-md-6">
      <label class="form-label general-text-6" for="providerSelect">
        Database Type<span class="text-danger">*</span>
      </label>
      <nz-select id="providerSelect" (ngModelChange)="onSelectChange($event)" [(ngModel)]="provider"
        [disabled]="configs?.isEdit" nzPlaceHolder="Select database type">
        <nz-option *ngFor="let option of providersFieldsList" [nzValue]="option.value"
          [nzLabel]="option.label"></nz-option>
      </nz-select>
    </div>
    } @else {

    <!-- Connection Name -->
    <div class="mb-3 col-md-12">
      <label class="form-label general-text-6" for="connName">
        Connection Name<span class="text-danger">*</span>
      </label>
      <input id="connName" type="text" [disabled]="configs?.isEdit" class="form-control" [(ngModel)]="connName"
        placeholder="Enter connection name" />
    </div>

    <!-- Provider -->

    <div class="mb-3" [class.col-md-12]="isAlm" [class.col-md-6]="!isAlm">
      <label class="form-label general-text-6" for="providerSelect">
        Provider<span class="text-danger">*</span>
      </label>
      <nz-select id="providerSelect" (ngModelChange)="onSelectChange($event)" [(ngModel)]="provider"
        [disabled]="configs?.isEdit" nzPlaceHolder="Select provider" nzShowSearch>
        <nz-option-group *ngFor="let group of options" [nzLabel]="group.label">
          <nz-option *ngFor="let option of group.options" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-option-group>
      </nz-select>
    </div>
    }



    <!-- model -->
    @if(models.length>0){
    <div class="mb-3 col-md-6">
      <label class="form-label general-text-6 " for="modelSelect">
        Model
      </label>
      <select id="modelSelect" [(ngModel)]="modelName" class="form-select" (change)="onModelSelectChange()">
        <option disabled selected value="">Select model</option>
        @for (item of models; track item?.value) {
        <option [value]="item.value">{{ item.label }}</option>
        }
      </select>
    </div>
    }
  </div>

  <app-dynamic-form
    *ngIf="configs?.isDynamic && dynamicFields.length > 0"
    [form]="dynamicForm"
    [formFields]="dynamicFields"
  ></app-dynamic-form>
</div>

<div class="modal-footer" *ngIf="!hideFooter">
  <div class="d-flex justify-content-end w-100">
    <button class="btn btn-accello-secondary mx-2" (click)="onCancel()">
      {{ embedded ? "Back" : "Cancel" }}
    </button>
    <button class="btn btn-accello-primary-light" (click)="submit()"
      [disabled]="!canSave || saving">
      <span *ngIf="saving" class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      {{ saving ? "Saving…" : (configs?.saveBtnText || "Add") }}
    </button>
  </div>
</div>
}